import React from 'react';
import { Loader, BaasicInput, BaasicSelect } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const MarketplaceOrderEditOrderLinesStepTemplate = ({
	t,
	marketplaceOrderEditViewStore: {
		form,
		loading,
		addOrderLine,
		orderLineStatusOptions,
		onSelectChange,
		onDelete,
		productOptions,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<div className="row">
				<div className="col col-sml-8">
					<div className="flex--secondary">
						<h3 className="spc--bottom--med title--primary">{t('MARKETPLACEORDEREDITFORM.TITLE.ORDERLINESSTEP')}</h3>
						<button className="btn btn--med btn--secondary spc--bottom--sml" onClick={addOrderLine} type="button">
							<i className="fa fa-plus spc--right--sml"></i> {t('MARKETPLACEORDEREDITFORM.ADDORDERLINE')}
						</button>
					</div>
					{form.$('orderLinesStep.orderLines').map(orderLine => {
						return (
							<div className="box--secondary box--sml spc--bottom--tny" key={orderLine.key}>
								{orderLine.key != 0 && (
									<div className="row">
										<div className="col col-sml-12">
											<div className="inputgroup type--right">
												<button
													className="btn btn--med btn--ghost react-filter-box-close"
													onClick={e => onDelete(e, orderLine)}
													type="button"
												>
													<i className="fa fa-times"></i>
												</button>
											</div>
										</div>
									</div>
								)}
								<div className="row">
									<div className="col col-sml-3 col-lrg-3 col-xxlrg-3">
										<BaasicSelect
											field={orderLine.$('product')}
											options={productOptions}
											value={orderLine.$('product').value}
											onChange={value => onSelectChange(value, orderLine.$('product'), true)}
										/>
									</div>
									<div className="col col-sml-3 col-lrg-3 col-xxlrg-3">
										<BaasicInput field={orderLine.$('quantity')} />
									</div>
									<div className="col col-sml-3 col-lrg-2 col-xxlrg-2">
										<BaasicInput field={orderLine.$('unitPrice')} />
									</div>
									<div className="col col-sml-2 col-lrg-2 col-xxlrg-2">
										<BaasicInput field={orderLine.$('taxPaid')} />
									</div>
									<div className="col col-sml-2 col-lrg-2 col-xxlrg-2">
										<BaasicSelect
											field={orderLine.$('orderLineStatus')}
											options={orderLineStatusOptions}
											value={orderLine.$('orderLineStatus').value}
											onChange={value => onSelectChange(value, orderLine.$('orderLineStatus'))}
										/>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
};

export default defaultTemplate(MarketplaceOrderEditOrderLinesStepTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/wizard/MarketplaceOrderEditOrderLinesStepTemplate.jsx